import { render, staticRenderFns } from "./TribunalDetails.vue?vue&type=template&id=60ce4b13"
import script from "./TribunalDetails.vue?vue&type=script&lang=js"
export * from "./TribunalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports